import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { CommonService } from '../../../../../shared/services/common.service';
import { IAReverseBuyerSellerTableModel } from '../../../../../shared/models/IA-ReverseBuyerSeller';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-reversebuyerseller',
  templateUrl: './reversebuyerseller.component.html',
  styleUrl: './reversebuyerseller.component.css'
})
export class ReversebuyersellerComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();


  dataSource!: MatTableDataSource<IAReverseBuyerSellerTableModel>
  displayedColumns: string[] = ['Sr.No', 'udyamRegistrationNumber', 'name', 'nameOfEnterprise', 'email', 'ownersMobileNumber','hsnCode']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  reportData: any[] = [];
  allrecord: any[] = [];


  ReverseBS: FormGroup;
  //dataSource: any[] = []; // Your full data source
  totalItems: number = 0; // Example total items
  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  ProposalList: any = []
 
 
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  itemsPerPage: number = 10;
  isDisabled = true;

  DtoPagination =
    {
      //"UserId": sessionStorage.getItem("iauserid"),
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "ASC",
      "SearchTerm": "",
      "SearchCol": ""
    }

  constructor(private router: Router, private apiService: ApiService, private toastr: ToastrService, private common: CommonService,) {
    this.ReverseBS = new FormGroup({
      searchControl: new FormControl('', [
        Validators.pattern(this.common.searchFilter)
      ])
    });
  }

  NewBuyer()
  {
    this.router.navigate(["/reversebuyerrequirement"]);
  }


  ngOnInit(): void {

    this.DtoPagination.PageSize = 10;
    this.DtoPagination.SearchCol = this.common.searchText;

    //this.DtoPagination.PageNumber = 1;
    //this.DtoPagination.PageSize = 10;
    //this.DtoPagination.SortColumn = "";
    //this.DtoPagination.SortDirection = "";
    //this.DtoPagination.SearchTerm = "";
    //this.LoadDetails(this.DtoPagination);
  }

  ngAfterViewInit() {
    this.LoadDetails();
  }


  //LoadDetails() {
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.common.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.REVERSEBUYERSELLER.GETBUYERSELLERMATCHES, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));

  //      }),
  //      map(resp => {
  //        if (resp.status) {
  //          this.length = resp['totalRecords'];
  //          //console.log(resp)
  //          //this.focusSectorDetails = resp.data; // Ensure this is correctly assigned
  //          // console.log("focus sector details:", this.focusSectorDetails)

  //        }
  //        return resp.data;

  //      })
  //    ).subscribe(data => {
  //      this.dataSource = new MatTableDataSource(data);
  //      //console.log("datasource", this.dataSource)
  //      //this.dataSource = data;
  //      this.adjustPaginator();
  //    });
  //}


  LoadDetails() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.common.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.REVERSEBUYERSELLER.GETBUYERSELLERMATCHES, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

   

  length: number = 0;
  pageSize: number = 10;
  displayedData: any[] = [];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {

    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.LoadDetails();
  }



  onSearchChange(event: Event): void {
    this.ReverseBS.get('searchControl')?.markAsTouched();
    const searchValue = (event.target as HTMLInputElement).value;
    if (this.ReverseBS.get('searchControl')?.valid) {
      this.DtoPagination.SearchTerm = searchValue;
      this.LoadDetails() // Fetch filtered data
    }
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.ReverseBS.get('searchControl');
    searchControl?.markAsTouched(); // Mark the control as touched for validation feedback

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.LoadDetails(); // Fetch filtered data
      //console.log('Search triggered with value:', searchValue);
    } else if (searchValue.trim() === '') {
      console.error('Search term is empty');
    } else {
      console.error('Invalid search term');
    }
  }

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.common.searchText;
    this.LoadDetails();
  }

  exportToExcel(): void {
    // Define the file name
    const fileName = 'Reverse_Buyers_Seller_Data.xlsx';

    const DtonullPagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: ""
    };

    this.apiService.getRequest(API_ENDPOINTS.REVERSEBUYERSELLER.GETBUYERSELLERMATCHES, DtonullPagination).subscribe({
      next: (result) => {
        if (!result || !result.status || !result.data) {
          this.toastr.error('No data available to export.');
          return;
        }

        this.allrecord = result.data;

        if (this.allrecord.length === 0) {
          this.toastr.error('No data available to export.');
          return;
        }

        // Prepare the data for export
        const excelData = this.allrecord.map((item, index) => ({
          'Sr. No': index + 1,
          'Udyam Registration Number': item.udyamRegistrationNumber,
          'Name': item.name,
          'Name of Enterprise': item.nameOfEnterprise,
          'Email': item.email,
          "Owner's Mobile Number": item.ownersMobileNumber,
          'HSN Code': item.hsnCode
        }));

        // Create a worksheet from the data
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

        // Auto-adjust column widths for better visibility
        const columnWidths = Object.keys(excelData[0]).map((key) => ({ wch: key.length + 5 }));
        worksheet['!cols'] = columnWidths;

        // Create a workbook and append the worksheet with the name "Reverse Buyers Seller Data"
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Reverse Buyers Seller Data': worksheet },
          SheetNames: ['Reverse Buyers Seller Data'],
        };

        // Generate a buffer for the Excel file
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        // Save the Excel file
        this.saveExcelFile(excelBuffer, fileName);
      },
      error: () => {
        this.toastr.error('Failed to fetch data for export.');
      }
    });
  }




  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }
}
